/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AutoProspectRouteImport } from './routes/auto-prospect'
import { Route as CoachRouteImport } from './routes/coach'
import { Route as CompaniesRouteImport } from './routes/companies'
import { Route as ComplianceRouteImport } from './routes/compliance'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as FinanceRouteImport } from './routes/finance'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as InquiriesRouteImport } from './routes/inquiries'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OcrRouteImport } from './routes/ocr'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as OutboundRouteImport } from './routes/outbound'
import { Route as PipelineRouteImport } from './routes/pipeline'
import { Route as QuotesRouteImport } from './routes/quotes'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SourcingRouteImport } from './routes/sourcing'
import { Route as CustomersCustomerIdRouteImport } from './routes/customers/$customerId'
import { Route as CustomersNewRouteImport } from './routes/customers.new'
import { Route as FinanceIndexRouteImport } from './routes/finance.index'
import { Route as FinanceArRouteImport } from './routes/finance.ar'
import { Route as FinanceCashflowRouteImport } from './routes/finance.cashflow'
import { Route as FinanceProfitRouteImport } from './routes/finance.profit'
import { Route as FinanceTaxRefundRouteImport } from './routes/finance.tax-refund'
import { Route as InquiriesInquiryIdRouteImport } from './routes/inquiries.$inquiryId'
import { Route as OcrHistoryRouteImport } from './routes/ocr.history'
import { Route as OrdersOrderIdRouteImport } from './routes/orders.$orderId'
import { Route as QuotesQuoteIdRouteImport } from './routes/quotes.$quoteId'
import { Route as QuotesNewRouteImport } from './routes/quotes.new'
import { Route as SourcingHistoryRouteImport } from './routes/sourcing.history'
import { Route as SourcingIntentRouteImport } from './routes/sourcing.intent'
import { Route as SourcingTemplatesRouteImport } from './routes/sourcing.templates'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AutoProspectRoute = AutoProspectRouteImport.update({
  id: '/auto-prospect',
  path: '/auto-prospect',
  getParentRoute: () => rootRouteImport,
} as any)
const CoachRoute = CoachRouteImport.update({
  id: '/coach',
  path: '/coach',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesRoute = CompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplianceRoute = ComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRoute = FinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const InquiriesRoute = InquiriesRouteImport.update({
  id: '/inquiries',
  path: '/inquiries',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OcrRoute = OcrRouteImport.update({
  id: '/ocr',
  path: '/ocr',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const OutboundRoute = OutboundRouteImport.update({
  id: '/outbound',
  path: '/outbound',
  getParentRoute: () => rootRouteImport,
} as any)
const PipelineRoute = PipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => rootRouteImport,
} as any)
const QuotesRoute = QuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SourcingRoute = SourcingRouteImport.update({
  id: '/sourcing',
  path: '/sourcing',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersCustomerIdRoute = CustomersCustomerIdRouteImport.update({
  id: '/$customerId',
  path: '/$customerId',
  getParentRoute: () => CustomersRoute,
} as any)
const CustomersNewRoute = CustomersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => CustomersRoute,
} as any)
const FinanceIndexRoute = FinanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FinanceRoute,
} as any)
const FinanceArRoute = FinanceArRouteImport.update({
  id: '/ar',
  path: '/ar',
  getParentRoute: () => FinanceRoute,
} as any)
const FinanceCashflowRoute = FinanceCashflowRouteImport.update({
  id: '/cashflow',
  path: '/cashflow',
  getParentRoute: () => FinanceRoute,
} as any)
const FinanceProfitRoute = FinanceProfitRouteImport.update({
  id: '/profit',
  path: '/profit',
  getParentRoute: () => FinanceRoute,
} as any)
const FinanceTaxRefundRoute = FinanceTaxRefundRouteImport.update({
  id: '/tax-refund',
  path: '/tax-refund',
  getParentRoute: () => FinanceRoute,
} as any)
const InquiriesInquiryIdRoute = InquiriesInquiryIdRouteImport.update({
  id: '/$inquiryId',
  path: '/$inquiryId',
  getParentRoute: () => InquiriesRoute,
} as any)
const OcrHistoryRoute = OcrHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => OcrRoute,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => OrdersRoute,
} as any)
const QuotesQuoteIdRoute = QuotesQuoteIdRouteImport.update({
  id: '/$quoteId',
  path: '/$quoteId',
  getParentRoute: () => QuotesRoute,
} as any)
const QuotesNewRoute = QuotesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => QuotesRoute,
} as any)
const SourcingHistoryRoute = SourcingHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => SourcingRoute,
} as any)
const SourcingIntentRoute = SourcingIntentRouteImport.update({
  id: '/intent',
  path: '/intent',
  getParentRoute: () => SourcingRoute,
} as any)
const SourcingTemplatesRoute = SourcingTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => SourcingRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auto-prospect': typeof AutoProspectRoute
  '/coach': typeof CoachRoute
  '/companies': typeof CompaniesRoute
  '/compliance': typeof ComplianceRoute
  '/customers': typeof CustomersRouteWithChildren
  '/finance': typeof FinanceRouteWithChildren
  '/inbox': typeof InboxRoute
  '/inquiries': typeof InquiriesRouteWithChildren
  '/login': typeof LoginRoute
  '/ocr': typeof OcrRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/orders': typeof OrdersRouteWithChildren
  '/outbound': typeof OutboundRoute
  '/pipeline': typeof PipelineRoute
  '/quotes': typeof QuotesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/sourcing': typeof SourcingRouteWithChildren
  '/customers/$customerId': typeof CustomersCustomerIdRoute
  '/customers/new': typeof CustomersNewRoute
  '/finance/ar': typeof FinanceArRoute
  '/finance/cashflow': typeof FinanceCashflowRoute
  '/finance/profit': typeof FinanceProfitRoute
  '/finance/tax-refund': typeof FinanceTaxRefundRoute
  '/inquiries/$inquiryId': typeof InquiriesInquiryIdRoute
  '/ocr/history': typeof OcrHistoryRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/quotes/$quoteId': typeof QuotesQuoteIdRoute
  '/quotes/new': typeof QuotesNewRoute
  '/sourcing/history': typeof SourcingHistoryRoute
  '/sourcing/intent': typeof SourcingIntentRoute
  '/sourcing/templates': typeof SourcingTemplatesRoute
  '/finance/': typeof FinanceIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auto-prospect': typeof AutoProspectRoute
  '/coach': typeof CoachRoute
  '/companies': typeof CompaniesRoute
  '/compliance': typeof ComplianceRoute
  '/customers': typeof CustomersRouteWithChildren
  '/inbox': typeof InboxRoute
  '/inquiries': typeof InquiriesRouteWithChildren
  '/login': typeof LoginRoute
  '/ocr': typeof OcrRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/orders': typeof OrdersRouteWithChildren
  '/outbound': typeof OutboundRoute
  '/pipeline': typeof PipelineRoute
  '/quotes': typeof QuotesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/sourcing': typeof SourcingRouteWithChildren
  '/customers/$customerId': typeof CustomersCustomerIdRoute
  '/customers/new': typeof CustomersNewRoute
  '/finance/ar': typeof FinanceArRoute
  '/finance/cashflow': typeof FinanceCashflowRoute
  '/finance/profit': typeof FinanceProfitRoute
  '/finance/tax-refund': typeof FinanceTaxRefundRoute
  '/inquiries/$inquiryId': typeof InquiriesInquiryIdRoute
  '/ocr/history': typeof OcrHistoryRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/quotes/$quoteId': typeof QuotesQuoteIdRoute
  '/quotes/new': typeof QuotesNewRoute
  '/sourcing/history': typeof SourcingHistoryRoute
  '/sourcing/intent': typeof SourcingIntentRoute
  '/sourcing/templates': typeof SourcingTemplatesRoute
  '/finance': typeof FinanceIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auto-prospect': typeof AutoProspectRoute
  '/coach': typeof CoachRoute
  '/companies': typeof CompaniesRoute
  '/compliance': typeof ComplianceRoute
  '/customers': typeof CustomersRouteWithChildren
  '/finance': typeof FinanceRouteWithChildren
  '/inbox': typeof InboxRoute
  '/inquiries': typeof InquiriesRouteWithChildren
  '/login': typeof LoginRoute
  '/ocr': typeof OcrRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/orders': typeof OrdersRouteWithChildren
  '/outbound': typeof OutboundRoute
  '/pipeline': typeof PipelineRoute
  '/quotes': typeof QuotesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/sourcing': typeof SourcingRouteWithChildren
  '/customers/$customerId': typeof CustomersCustomerIdRoute
  '/customers/new': typeof CustomersNewRoute
  '/finance/ar': typeof FinanceArRoute
  '/finance/cashflow': typeof FinanceCashflowRoute
  '/finance/profit': typeof FinanceProfitRoute
  '/finance/tax-refund': typeof FinanceTaxRefundRoute
  '/inquiries/$inquiryId': typeof InquiriesInquiryIdRoute
  '/ocr/history': typeof OcrHistoryRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/quotes/$quoteId': typeof QuotesQuoteIdRoute
  '/quotes/new': typeof QuotesNewRoute
  '/sourcing/history': typeof SourcingHistoryRoute
  '/sourcing/intent': typeof SourcingIntentRoute
  '/sourcing/templates': typeof SourcingTemplatesRoute
  '/finance/': typeof FinanceIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auto-prospect'
    | '/coach'
    | '/companies'
    | '/compliance'
    | '/customers'
    | '/finance'
    | '/inbox'
    | '/inquiries'
    | '/login'
    | '/ocr'
    | '/onboarding'
    | '/orders'
    | '/outbound'
    | '/pipeline'
    | '/quotes'
    | '/settings'
    | '/sourcing'
    | '/customers/$customerId'
    | '/customers/new'
    | '/finance/ar'
    | '/finance/cashflow'
    | '/finance/profit'
    | '/finance/tax-refund'
    | '/inquiries/$inquiryId'
    | '/ocr/history'
    | '/orders/$orderId'
    | '/quotes/$quoteId'
    | '/quotes/new'
    | '/sourcing/history'
    | '/sourcing/intent'
    | '/sourcing/templates'
    | '/finance/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auto-prospect'
    | '/coach'
    | '/companies'
    | '/compliance'
    | '/customers'
    | '/inbox'
    | '/inquiries'
    | '/login'
    | '/ocr'
    | '/onboarding'
    | '/orders'
    | '/outbound'
    | '/pipeline'
    | '/quotes'
    | '/settings'
    | '/sourcing'
    | '/customers/$customerId'
    | '/customers/new'
    | '/finance/ar'
    | '/finance/cashflow'
    | '/finance/profit'
    | '/finance/tax-refund'
    | '/inquiries/$inquiryId'
    | '/ocr/history'
    | '/orders/$orderId'
    | '/quotes/$quoteId'
    | '/quotes/new'
    | '/sourcing/history'
    | '/sourcing/intent'
    | '/sourcing/templates'
    | '/finance'
  id:
    | '__root__'
    | '/'
    | '/auto-prospect'
    | '/coach'
    | '/companies'
    | '/compliance'
    | '/customers'
    | '/finance'
    | '/inbox'
    | '/inquiries'
    | '/login'
    | '/ocr'
    | '/onboarding'
    | '/orders'
    | '/outbound'
    | '/pipeline'
    | '/quotes'
    | '/settings'
    | '/sourcing'
    | '/customers/$customerId'
    | '/customers/new'
    | '/finance/ar'
    | '/finance/cashflow'
    | '/finance/profit'
    | '/finance/tax-refund'
    | '/inquiries/$inquiryId'
    | '/ocr/history'
    | '/orders/$orderId'
    | '/quotes/$quoteId'
    | '/quotes/new'
    | '/sourcing/history'
    | '/sourcing/intent'
    | '/sourcing/templates'
    | '/finance/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AutoProspectRoute: typeof AutoProspectRoute
  CoachRoute: typeof CoachRoute
  CompaniesRoute: typeof CompaniesRoute
  ComplianceRoute: typeof ComplianceRoute
  CustomersRoute: typeof CustomersRouteWithChildren
  FinanceRoute: typeof FinanceRouteWithChildren
  InboxRoute: typeof InboxRoute
  InquiriesRoute: typeof InquiriesRouteWithChildren
  LoginRoute: typeof LoginRoute
  OcrRoute: typeof OcrRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  OrdersRoute: typeof OrdersRouteWithChildren
  OutboundRoute: typeof OutboundRoute
  PipelineRoute: typeof PipelineRoute
  QuotesRoute: typeof QuotesRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  SourcingRoute: typeof SourcingRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auto-prospect': {
      id: '/auto-prospect'
      path: '/auto-prospect'
      fullPath: '/auto-prospect'
      preLoaderRoute: typeof AutoProspectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coach': {
      id: '/coach'
      path: '/coach'
      fullPath: '/coach'
      preLoaderRoute: typeof CoachRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies': {
      id: '/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof CompaniesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance': {
      id: '/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof ComplianceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inquiries': {
      id: '/inquiries'
      path: '/inquiries'
      fullPath: '/inquiries'
      preLoaderRoute: typeof InquiriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ocr': {
      id: '/ocr'
      path: '/ocr'
      fullPath: '/ocr'
      preLoaderRoute: typeof OcrRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/outbound': {
      id: '/outbound'
      path: '/outbound'
      fullPath: '/outbound'
      preLoaderRoute: typeof OutboundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pipeline': {
      id: '/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof PipelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quotes': {
      id: '/quotes'
      path: '/quotes'
      fullPath: '/quotes'
      preLoaderRoute: typeof QuotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sourcing': {
      id: '/sourcing'
      path: '/sourcing'
      fullPath: '/sourcing'
      preLoaderRoute: typeof SourcingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$customerId': {
      id: '/customers/$customerId'
      path: '/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof CustomersCustomerIdRouteImport
      parentRoute: typeof CustomersRoute
    }
    '/customers/new': {
      id: '/customers/new'
      path: '/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof CustomersNewRouteImport
      parentRoute: typeof CustomersRoute
    }
    '/finance/': {
      id: '/finance/'
      path: '/'
      fullPath: '/finance/'
      preLoaderRoute: typeof FinanceIndexRouteImport
      parentRoute: typeof FinanceRoute
    }
    '/finance/ar': {
      id: '/finance/ar'
      path: '/ar'
      fullPath: '/finance/ar'
      preLoaderRoute: typeof FinanceArRouteImport
      parentRoute: typeof FinanceRoute
    }
    '/finance/cashflow': {
      id: '/finance/cashflow'
      path: '/cashflow'
      fullPath: '/finance/cashflow'
      preLoaderRoute: typeof FinanceCashflowRouteImport
      parentRoute: typeof FinanceRoute
    }
    '/finance/profit': {
      id: '/finance/profit'
      path: '/profit'
      fullPath: '/finance/profit'
      preLoaderRoute: typeof FinanceProfitRouteImport
      parentRoute: typeof FinanceRoute
    }
    '/finance/tax-refund': {
      id: '/finance/tax-refund'
      path: '/tax-refund'
      fullPath: '/finance/tax-refund'
      preLoaderRoute: typeof FinanceTaxRefundRouteImport
      parentRoute: typeof FinanceRoute
    }
    '/inquiries/$inquiryId': {
      id: '/inquiries/$inquiryId'
      path: '/$inquiryId'
      fullPath: '/inquiries/$inquiryId'
      preLoaderRoute: typeof InquiriesInquiryIdRouteImport
      parentRoute: typeof InquiriesRoute
    }
    '/ocr/history': {
      id: '/ocr/history'
      path: '/history'
      fullPath: '/ocr/history'
      preLoaderRoute: typeof OcrHistoryRouteImport
      parentRoute: typeof OcrRoute
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/quotes/$quoteId': {
      id: '/quotes/$quoteId'
      path: '/$quoteId'
      fullPath: '/quotes/$quoteId'
      preLoaderRoute: typeof QuotesQuoteIdRouteImport
      parentRoute: typeof QuotesRoute
    }
    '/quotes/new': {
      id: '/quotes/new'
      path: '/new'
      fullPath: '/quotes/new'
      preLoaderRoute: typeof QuotesNewRouteImport
      parentRoute: typeof QuotesRoute
    }
    '/sourcing/history': {
      id: '/sourcing/history'
      path: '/history'
      fullPath: '/sourcing/history'
      preLoaderRoute: typeof SourcingHistoryRouteImport
      parentRoute: typeof SourcingRoute
    }
    '/sourcing/intent': {
      id: '/sourcing/intent'
      path: '/intent'
      fullPath: '/sourcing/intent'
      preLoaderRoute: typeof SourcingIntentRouteImport
      parentRoute: typeof SourcingRoute
    }
    '/sourcing/templates': {
      id: '/sourcing/templates'
      path: '/templates'
      fullPath: '/sourcing/templates'
      preLoaderRoute: typeof SourcingTemplatesRouteImport
      parentRoute: typeof SourcingRoute
    }
  }
}

interface CustomersRouteChildren {
  CustomersCustomerIdRoute: typeof CustomersCustomerIdRoute
  CustomersNewRoute: typeof CustomersNewRoute
}

const CustomersRouteChildren: CustomersRouteChildren = {
  CustomersCustomerIdRoute: CustomersCustomerIdRoute,
  CustomersNewRoute: CustomersNewRoute,
}

const CustomersRouteWithChildren = CustomersRoute._addFileChildren(
  CustomersRouteChildren,
)

interface FinanceRouteChildren {
  FinanceArRoute: typeof FinanceArRoute
  FinanceCashflowRoute: typeof FinanceCashflowRoute
  FinanceProfitRoute: typeof FinanceProfitRoute
  FinanceTaxRefundRoute: typeof FinanceTaxRefundRoute
  FinanceIndexRoute: typeof FinanceIndexRoute
}

const FinanceRouteChildren: FinanceRouteChildren = {
  FinanceArRoute: FinanceArRoute,
  FinanceCashflowRoute: FinanceCashflowRoute,
  FinanceProfitRoute: FinanceProfitRoute,
  FinanceTaxRefundRoute: FinanceTaxRefundRoute,
  FinanceIndexRoute: FinanceIndexRoute,
}

const FinanceRouteWithChildren =
  FinanceRoute._addFileChildren(FinanceRouteChildren)

interface InquiriesRouteChildren {
  InquiriesInquiryIdRoute: typeof InquiriesInquiryIdRoute
}

const InquiriesRouteChildren: InquiriesRouteChildren = {
  InquiriesInquiryIdRoute: InquiriesInquiryIdRoute,
}

const InquiriesRouteWithChildren = InquiriesRoute._addFileChildren(
  InquiriesRouteChildren,
)

interface OcrRouteChildren {
  OcrHistoryRoute: typeof OcrHistoryRoute
}

const OcrRouteChildren: OcrRouteChildren = {
  OcrHistoryRoute: OcrHistoryRoute,
}

const OcrRouteWithChildren = OcrRoute._addFileChildren(OcrRouteChildren)

interface OrdersRouteChildren {
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute
}

const OrdersRouteChildren: OrdersRouteChildren = {
  OrdersOrderIdRoute: OrdersOrderIdRoute,
}

const OrdersRouteWithChildren =
  OrdersRoute._addFileChildren(OrdersRouteChildren)

interface QuotesRouteChildren {
  QuotesQuoteIdRoute: typeof QuotesQuoteIdRoute
  QuotesNewRoute: typeof QuotesNewRoute
}

const QuotesRouteChildren: QuotesRouteChildren = {
  QuotesQuoteIdRoute: QuotesQuoteIdRoute,
  QuotesNewRoute: QuotesNewRoute,
}

const QuotesRouteWithChildren =
  QuotesRoute._addFileChildren(QuotesRouteChildren)

interface SourcingRouteChildren {
  SourcingHistoryRoute: typeof SourcingHistoryRoute
  SourcingIntentRoute: typeof SourcingIntentRoute
  SourcingTemplatesRoute: typeof SourcingTemplatesRoute
}

const SourcingRouteChildren: SourcingRouteChildren = {
  SourcingHistoryRoute: SourcingHistoryRoute,
  SourcingIntentRoute: SourcingIntentRoute,
  SourcingTemplatesRoute: SourcingTemplatesRoute,
}

const SourcingRouteWithChildren = SourcingRoute._addFileChildren(
  SourcingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AutoProspectRoute: AutoProspectRoute,
  CoachRoute: CoachRoute,
  CompaniesRoute: CompaniesRoute,
  ComplianceRoute: ComplianceRoute,
  CustomersRoute: CustomersRouteWithChildren,
  FinanceRoute: FinanceRouteWithChildren,
  InboxRoute: InboxRoute,
  InquiriesRoute: InquiriesRouteWithChildren,
  LoginRoute: LoginRoute,
  OcrRoute: OcrRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  OrdersRoute: OrdersRouteWithChildren,
  OutboundRoute: OutboundRoute,
  PipelineRoute: PipelineRoute,
  QuotesRoute: QuotesRouteWithChildren,
  SettingsRoute: SettingsRoute,
  SourcingRoute: SourcingRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
